'use strict';

import * as util from '../util/Common.js';
import {Point2D} from '../util/Geometry.js';
import * as domUtil from '../util/Dom.js';
import {SlideBar} from './SlideBar.js';
import {UiComponent} from '../ui/UiComponent.js';
import {RelativeContainer} from '../ui/RelativeContainer.js';

const privateMap = util.createPrivateMapper();

function isLoadTarget(url){
  if (url.indexOf('blob:') === 0) {
    return false
  } else if (url.indexOf('data:') === 0) {
    return false
  }
  return true
}
const KB = 1024;
const ByteUnit = {
  'GB': KB * KB * KB,
  'MB': KB * KB,
  'KB': KB,
}
function byteExp(v){
  if (!v || isNaN(v)) {
    return '-'
  }
  if (v < KB) {
    return '' + v + ' bytes'
  }
  for (let bu in ByteUnit) {
    if (v >= ByteUnit[bu]) {
      return (v / ByteUnit[bu]).toFixed(2) + ' ' + bu
    }
  }
}

function defaultLoadingExp(loaded, total) {
  return byteExp(loaded)
  // return byteExp(total) + ' : ' + byteExp(loaded)
}

export class LoadingIndicator extends UiComponent {
  constructor(domEl, options){
    super(domEl);
    const pv = privateMap(this);

    pv.loadingExp = options.loadingExp ? options.loadingExp : defaultLoadingExp
    pv.onProgress = options.onProgress
    pv.onClose = options.onClose
    pv.loadedCount = 0;
    pv.messages = {
      'loading': 'Loading...',
      'waiting': 'Waiting...',
      'processing': 'Processing...',
      ...options.messages
    };
    pv.messageEl = options.messageEl;
    pv.progressBarContainerEl = options.progressBarEl.parentNode;
    pv.progressBarEl = options.progressBarEl;
    pv.progressBarTextSelector = options.progressBarTextSelector;
    pv.progressBarProgressSelector = options.progressBarProgressSelector;
    pv.progressBars = null;
    this.active = false;
  }

  open(){
    const pv = privateMap(this);
    domUtil.empty(pv.messageEl);
    domUtil.empty(pv.progressBarContainerEl)
    pv.messageEl.appendChild(domUtil.text(pv.messages['loading']));
    domUtil.setStyle(pv.progressBarEl.querySelector(pv.progressBarProgressSelector), 'width', '0%');

    const textEl = pv.progressBarEl.querySelector(pv.progressBarTextSelector)
    domUtil.empty(textEl);
    textEl.appendChild(domUtil.text(pv.messages['waiting']));
    pv.progressBarContainerEl.appendChild(pv.progressBarEl)

    pv.progressBars = null;
    pv.loadingCount = 0;
    this.active = true;
  }
  itemStart(url){
    if (!isLoadTarget(url)) {
      return
    }
    const pv = privateMap(this);
    let progressBarEl;
    if (!pv.progressBars) {
      pv.progressBars = {}
      progressBarEl = pv.progressBarEl
    } else {
      progressBarEl = pv.progressBars[url]
      if (progressBarEl) {
        return
      }
      progressBarEl = pv.progressBarEl.cloneNode(true)
      pv.progressBarContainerEl.appendChild(progressBarEl)
    }
    if (!progressBarEl.parentNode) {
      pv.progressBarContainerEl.appendChild(progressBarEl)
    }
    pv.loadingCount++;
    pv.progressBars[url] = {
      loaded: false,
      el: progressBarEl
    }
    domUtil.empty(pv.messageEl)
    pv.messageEl.appendChild(domUtil.text(pv.messages['loading']));

    const textEl = progressBarEl.querySelector(pv.progressBarTextSelector)
    domUtil.empty(textEl);
    textEl.appendChild(domUtil.text(pv.messages['waiting']));

    // domUtil.empty(pv.itemsEl);
    // pv.itemsEl.appendChild(domUtil.text(itemsLoaded + '/' + itemsTotal));
    domUtil.setStyle(progressBarEl.querySelector(pv.progressBarProgressSelector), 'width', '0%');
  }
  itemProgress(url){
    if (!isLoadTarget(url)) {
      return
    }
    const pv = privateMap(this);
    const progressBar = pv.progressBars[url];
    if (!progressBar || progressBar.loaded) {
      return
    }
    pv.loadingCount--;
    
    if (pv.loadingCount == 0) {
      domUtil.empty(pv.messageEl)
      pv.messageEl.appendChild(domUtil.text(pv.messages['processing']));
    }
    progressBar.loaded = true
    const progressBarEl = progressBar.el;

    const textEl = progressBarEl.querySelector(pv.progressBarTextSelector)
    domUtil.empty(textEl);
    // textEl.appendChild(domUtil.text(url));

    domUtil.setStyle(progressBarEl.querySelector(pv.progressBarProgressSelector), 'width', '100%');
    pv.progressBarContainerEl.removeChild(progressBarEl)
  }
  // completed(){
  //   const pv = privateMap(this);
  //   domUtil.empty(pv.messageEl);
  //   pv.messageEl.appendChild(domUtil.text(pv.messages['initializing']));
  // }
  progress(ev, url){
    const pv = privateMap(this);
    let progressBarEl
    if (url) {
      const progressBar = pv.progressBars[url]
      if (!progressBar || progressBar.loaded) {
        return
      }
      progressBarEl = progressBar.el
    } else {
      progressBarEl = pv.progressBarEl
    }
    if (!progressBarEl.parentNode) {
      pv.progressBarContainerEl.appendChild(progressBarEl)
    }
    if (ev.target && ev.target.readyState == 4) {
      domUtil.setStyle(progressBarEl.querySelector(pv.progressBarProgressSelector), 'width', '100%');
      return;
    }
    // domUtil.empty(pv.progressBarEl);
    // pv.progressBarEl.appendChild(domUtil.text(ev.loaded))
    const textEl = progressBarEl.querySelector(pv.progressBarTextSelector)
    domUtil.empty(textEl);
    textEl.appendChild(domUtil.text(pv.loadingExp(ev.loaded, ev.total)));
    let progress = 0;
    if (ev.total) {
      progress = 100 * ev.loaded / ev.total;
    }
    domUtil.setStyle(progressBarEl.querySelector(pv.progressBarProgressSelector), 'width', (progress).toFixed(10) + '%');
    if (pv.onProgress) {
      pv.onProgress(ev)
    }
  }
  close(){
    const pv = privateMap(this);
    this.active = false;
    if (pv.onClose) {
      pv.onClose()
    }
  }
}